import Menu from '../Menu/Menu'
import './Header.css'

const Header = () => {
  return (
    <header id="masthead">
      <Menu />
    </header>
  )
}

export default Header
